import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {Box, IconButton, Tooltip} from "@mui/material";
import React from "react";

export const BALANCE_VALIDATION_STATUS = Object.freeze({
    FAILED: "FAILED",
    NONE: "NONE",
    SUCCESS: "SUCCESS",
});

const BALANCE_VALIDATION_REPORTS = {
    [BALANCE_VALIDATION_STATUS.FAILED]: {
        severity: "error",
        title: "Validation failed",
    },
    [BALANCE_VALIDATION_STATUS.SUCCESS]: {
        severity: "success",
        title: "Validation passed",
    },
};

export const getBalanceValidationReport = (status) =>
    BALANCE_VALIDATION_REPORTS[status] ?? null;

export const isBalanceValidationEnabled = (domainAlias) => domainAlias === "cm";

export default function BalanceValidationReport({status, buildLink}) {
    const report = getBalanceValidationReport(status);

    if (!report) return "Validation not run";

    const ValidationIcon = report.severity === "success" ? CheckCircleOutlineIcon : ErrorOutlineIcon;

    return (
        <Box
            sx={{
                alignItems: "center",
                color: `${report.severity}.main`,
                display: "inline-flex",
                gap: 0.5,
                whiteSpace: "nowrap",
            }}
        >
            {report.title}
            {buildLink &&
                <Tooltip title="Open validation build">
                    <IconButton
                        aria-label="Open validation build"
                        component="a"
                        href={buildLink}
                        rel="noopener noreferrer"
                        size="small"
                        sx={{color: "inherit", p: 0}}
                        target="_blank"
                    >
                        <ValidationIcon fontSize="small"/>
                    </IconButton>
                </Tooltip>
            }
        </Box>
    );
}
